module.exports = __webpack_public_path__ + "87b8397f50672a1419907ae62936f5d4.svg";